import { ComLog } from '../../../types/monitoring'
import MonitoringFormListRowMobile from './MonitoringFormListRowMobile'
import MonitoringFormListRowSkeleton from './MonitoringFormListRowSkeleton.skeleton'
import MonitoringFormListTableHeadMobile from './MonitoringFormListTableHeadMobile'

interface MonitoringFormListMobileProps {
  listData: ComLog[] | undefined
}
const MonitoringFormListMobile: React.FC<MonitoringFormListMobileProps> = ({
  listData
}) => {
  return (
    <div>
      <MonitoringFormListTableHeadMobile />
      {listData
        ? listData.map((item, index) => (
            <MonitoringFormListRowMobile
              data={item}
              key={item.Id + index.toString()}
            />
          ))
        : Array(6)
            .fill(null)
            .map((item, index) => (
              <MonitoringFormListRowSkeleton isMobile key={index.toString()} />
            ))}
    </div>
  )
}
export default MonitoringFormListMobile
